export default __webpack_public_path__ + "media/zurb/img/ecommerce/tmw_comp_2-ec2dbf2b7e3f7285106f849d6619f41d.png";